import { render, staticRenderFns } from "./indexFree.vue?vue&type=template&id=4e1ec2d2&scoped=true&"
import script from "./indexFree.vue?vue&type=script&lang=js&"
export * from "./indexFree.vue?vue&type=script&lang=js&"
import style0 from "./indexFree.vue?vue&type=style&index=0&id=4e1ec2d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ec2d2",
  null
  
)

export default component.exports